import { PropsWithChildren } from "react";
import styled from "styled-components";
import { shade0 } from "@songtradr-one/components-frontend";

// TEXT

// STYLES
export const Wrapper = styled.div<{ $topPadding?: boolean }>`
  gap: 2rem;
  width: 100%;
  display: flex;
  padding: ${(props) => (props.$topPadding ? "10svh 0 0" : "0")};
  text-align: center;
  align-items: center;
  flex-direction: column;

  color: ${shade0};
`;

// DATA

// TYPES
export interface EmptyStateProps extends PropsWithChildren {
  title?: string;
  text?: string;
  topPadding?: boolean;
}

// CONSTANTS

// FUNCTIONS

// ASSETS
